import { Link } from 'react-router-dom';
import { Phone, Mail, ShieldCheck, Clock } from 'lucide-react';

export default function Footer() {
  return (
    <footer className="bg-brand-secondary text-brand-dark pt-16 pb-8 border-t border-brand-dark/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 pb-12 border-b border-brand-dark/10">
          
          {/* Virksomhedsinfo & Logo */}
          <div className="space-y-6">
            <div className="inline-block bg-white p-2.5 rounded-lg shadow-sm">
              <img
                src="https://assets.auxodev.dk/cdn-cgi/image/width=280,quality=95,format=auto/assets/ecc7c3d2-b2a3-4a1d-ba29-5687874f0c20/logo.jpg"
                alt="FLOW Transport & Logistik ApS Logo"
                className="h-16 w-auto object-contain"
              />
            </div>
            <p className="text-sm text-brand-dark/80 leading-relaxed max-w-sm">
              FLOW Transport & Logistik ApS er din professionelle og driftssikre transportpartner. Vi leverer skræddersyede logistikløsninger i hele Danmark med fokus på pålidelighed og høj service.
            </p>
            <div className="text-xs text-brand-dark/60">
              CVR-nr: <span className="font-semibold text-brand-dark">46483057</span>
            </div>
          </div>

          {/* Hurtige Links */}
          <div className="space-y-6">
            <h3 className="text-brand-dark font-bold text-base tracking-wide uppercase">Hurtige links</h3>
            <ul className="space-y-3 text-sm">
              <li>
                <Link to="/" className="text-brand-dark/80 hover:text-brand-primary transition-colors font-medium">Forside</Link>
              </li>
              <li>
                <Link to="/ydelser" className="text-brand-dark/80 hover:text-brand-primary transition-colors font-medium">Ydelser</Link>
              </li>
              <li>
                <Link to="/om-os" className="text-brand-dark/80 hover:text-brand-primary transition-colors font-medium">Om os</Link>
              </li>
              <li>
                <Link to="/priser" className="text-brand-dark/80 hover:text-brand-primary transition-colors font-medium">Priser</Link>
              </li>
              <li>
                <Link to="/kontakt" className="text-brand-dark/80 hover:text-brand-primary transition-colors font-medium">Kontakt</Link>
              </li>
            </ul>
          </div>

          {/* Kontaktoplysninger */}
          <div className="space-y-6">
            <h3 className="text-brand-dark font-bold text-base tracking-wide uppercase">Kontaktoplysninger</h3>
            <ul className="space-y-4 text-sm">
              <li className="flex items-center gap-3">
                <Phone className="h-5 w-5 text-brand-primary shrink-0" />
                <a
                  href="tel:+4522289310"
                  className="text-brand-dark hover:text-brand-primary transition-colors font-semibold whitespace-nowrap"
                >
                  22 28 93 10
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Mail className="h-5 w-5 text-brand-primary shrink-0" />
                <a
                  href="mailto:kontakt@flowtl.dk"
                  className="text-brand-dark hover:text-brand-primary transition-colors font-semibold whitespace-nowrap"
                >
                  kontakt@flowtl.dk
                </a>
              </li>
            </ul>
          </div>

        </div>

        {/* Bund-bar */}
        <div className="pt-8 flex flex-col sm:flex-row justify-between items-center gap-4 text-xs text-brand-dark/60">
          <p>© {new Date().getFullYear()} FLOW Transport & Logistik ApS. Alle rettigheder forbeholdes.</p>
          <div className="flex items-center gap-1.5 text-brand-dark/80">
            <ShieldCheck className="h-4 w-4 text-brand-primary" />
            <span>100% driftssikkert og professionelt dansk transportfirma</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
